import StepSync from './src/steps-bottom';

export default StepSync;
